import React, { Fragment } from 'react'
import CheckboxesGroup from './CheckboxesGroup'
import { makeStyles, Typography } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
   listTitle: {
      fontSize: 16,
      fontWeight: 700,
      marginTop: theme.spacing(1)
   }
}))

const CheckboxesLists = ({ optionsLists, handleSelection }) => {
   const classes = useStyles()
   return (
      <Fragment>
         {Object.keys(optionsLists).map(optionListId => {
            const optionsList = optionsLists[optionListId]
            if (optionsList.visible) {
               return (
                  <Fragment key={optionListId}>
                     <Typography className={classes.listTitle}>
                        {optionsList.name}
                     </Typography>
                     <CheckboxesGroup
                        items={optionsList.itemsMap}
                        parentOptionId={optionListId}
                        handleSelection={handleSelection}
                     />
                  </Fragment>
               )
            }
         })}
      </Fragment>
   )
}

export default CheckboxesLists
